import React from "react";
import { Helmet } from "react-helmet";


const PrivacyPolicy = () => {
  return (
    <>
     <Helmet>
        <title>Privacy Policy – Webs2PDF | Your Data, Protected</title>
        <meta
          name="description"
          content="Learn how Webs2PDF collects, stores, and protects your personal data. We value your privacy and ensure full compliance with data protection regulations."
        />
        <link rel="canonical" href="https://webs2pdf.com/privacy-policy" />
        <meta name="description" content="" data-react-helmet="true" />
      </Helmet>
      <div className="hero-section-wrap policy-wrap">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>
            <b>Effective Date::</b> June 20, 2025
          </p>

          <h3>Information We Collect</h3>

          <ul>
            <li>
              <strong>Automatically: </strong> IP address, browser type/version,
              referring URLs, and anonymous usage analytics.
            </li>
            <li>
              <strong>Voluntarily: </strong> Email address and any message
              content you provide when contacting support.
            </li>
            <li>
              <strong>We do not store </strong> the content of webpages you
              convert or retain generated PDFs beyond the processing session.
            </li>
          </ul>

          <h3>Cookies & Analytics</h3>
          <p>
            We use essential cookies for functionality and third‐party analytics
            tools (e.g., Google Analytics) to understand aggregated traffic
            patterns. You can disable cookies in your browser, but parts of the
            Site may not function correctly.
          </p>

          <h3>How We Use Data</h3>
          <ul>
            <li>Operate and improve the Service.</li>
            <li>Diagnose technical issues.</li>
            <li>
              Respond to support requests. We do not sell or rent personal data
              to third parties.
            </li>
          </ul>

          <h3>Sharing & Retention</h3>
          <p>
            Minimal logs are retained for security and auditing; analytics data
            is anonymized and purged periodically. No PDFs or source URLs are
            archived after completion of the conversion process.
          </p>

          <h3>Your Rights</h3>
          <p>
            You may request access to or deletion of personal data by emailing
            us at{" "}
            <a href="mailto:info@webs2pdf.com">
              <b>info@webs2pdf.com.</b>
            </a>{" "}
            We will respond within 30 days, subject to verification of identity.
          </p>

          <h3>Policy Updates</h3>
          <p>
            We may update this Privacy Policy from time to time. The "Effective
            Date" will reflect the latest revision.
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
